import {
  MeasurementLayerInput,
  PlateMapPositionInput,
} from 'samples/plate-maps/plate-record/PlateRecordConstants';
import {
  PlateMapValidationResponse,
  PlateDesignValidationResponse,
} from 'samples/plate-maps/validation/ValidationTypes';
import * as net from 'util/Net';

export interface ValidatePlateMapParams {
  positionInputs: Array<PlateMapPositionInput>;
  plateId: string | null;
  plateSchemaId: string | null;
  documentId: string | null;
  measurementLayers?: Array<MeasurementLayerInput> | null;
}

export function validatePlateMap(data: ValidatePlateMapParams): Promise<PlateMapValidationResponse> {
  return net.postJSONPromise({url: '/1/api/plate-maps/validate-plate-map', data});
}

export function validatePlateDesign(plateDesignId: string): Promise<PlateDesignValidationResponse> {
  return net.postJSONPromise({url: `/1/api/plate-design/${plateDesignId}/validate`, data: {}});
}
